import type { FC } from 'react';
import { Tab } from '@hopskipdrive/react-components';

import { RIDE_STATES_QUERY } from '../../../constants';
import { REMOVED_RIDERS_TAB, type RidesTab } from '../../hooks/useRidesTabs';

import { RideTabs, TabsContainer } from './styles';

interface RidesTabsProps {
  value: RidesTab | false;
  onChange: (nextTab: string) => void;
}

export const RidesTabs: FC<RidesTabsProps> = ({ value, onChange }) => {
  return (
    <TabsContainer>
      <RideTabs
        value={value}
        data-testid="tabs-nav"
        variant="scrollable"
        onChange={(_event, nextTab) => onChange(nextTab)}
      >
        <Tab label="In Progress & Upcoming" value={RIDE_STATES_QUERY.upcoming} />
        <Tab label="Completed" value={RIDE_STATES_QUERY.completed} />
        <Tab label="Canceled" value={RIDE_STATES_QUERY.allCanceled} />
        <Tab
          label="Removed"
          value={REMOVED_RIDERS_TAB}
          onClick={() => {
            // Re-clicking Removed clears its URL filters, even when selection stays unchanged.
            if (value === REMOVED_RIDERS_TAB) {
              onChange(REMOVED_RIDERS_TAB);
            }
          }}
        />
        <Tab label="Requested" value={RIDE_STATES_QUERY.requested} />
      </RideTabs>
    </TabsContainer>
  );
};
